
import { Component } from '@angular/core';

@Component({
  selector: 'sl-modal-body',
  standalone: true,
  imports: [],
  templateUrl: './sl-modal-body.component.html',
  styleUrl: './sl-modal-body.component.scss',
})
export class SlModalBodyComponent {}
